/**
 * Custom panel button placeholder component.
 * This file is overridden by jitsi-meet-branding at build time
 * to provide the actual button implementation with custom icon.
 *
 * @returns {null} This placeholder renders nothing.
 */
const CustomPanelButton = () => null;
export default CustomPanelButton;
